/**
 * Visual dos cartões de reconhecimento (recebidos e enviados), transcrito do
 * Meu Perfil.dc.html. Os dois componentes têm lógicas diferentes, mas o mesmo
 * cartão: as classes moram aqui para não divergirem.
 */
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const CONTADOR_DA_LISTA = 'text-brand-blue';

export const FORM_DE_BUSCA =
  'flex min-w-[280px] max-w-[420px] flex-1 items-center gap-2.5 rounded-jj-pill border border-line bg-surface-0 px-[18px] py-2.5 shadow-jj-01';
// 16px no mobile evita o zoom automático do iOS no foco; 14px no desktop, como no design.
export const CAMPO_DE_BUSCA =
  'min-w-0 flex-1 border-0 bg-transparent text-base text-content outline-none placeholder:text-content-soft lg:text-sm';

export const GRADE_DE_CARTOES = 'grid grid-cols-1 items-start gap-5 lg:grid-cols-2';
export const CARTAO = 'flex flex-col gap-[18px] rounded-xl bg-surface-200 px-6 py-6 text-content lg:px-[26px]';

export const LINHA_DO_NOME = 'm-0 font-display text-[19px] font-bold leading-[1.15]';
export const NOME = 'text-brand-pink';
export const MATRICULA = 'text-brand-blue';
export const DATA_DE_ENVIO = 'text-sm text-content';

export const CHIP = 'inline-flex items-center gap-2.5 rounded-jj-pill bg-surface-0 px-5 py-[7px] text-sm text-content shadow-jj-01';
export const CHIP_MOEDA = `${CHIP} font-display font-bold`;
export const CHIP_TOTAL = 'rounded-jj-pill bg-brand-purple-light px-[22px] py-[11px] text-sm text-content';
export const CHIP_ALERTA = 'inline-flex items-center gap-2 rounded-jj-pill bg-surface-0 px-4 py-[7px] text-xs text-brand-pink shadow-jj-01';

export const DIVISOR = 'border-t border-[rgba(0,45,75,0.14)] pt-4';
export const ROTULO_DA_MENSAGEM = 'mb-[5px] font-display text-[15px] font-bold text-content';
export const TEXTO_DA_MENSAGEM = 'text-[15px] leading-normal text-content';

export const ACOES = 'mt-auto flex flex-wrap items-center justify-end gap-[30px]';
export const ACAO = 'flex items-center gap-[9px] border-0 bg-transparent text-[15px] text-content';
export const ACAO_ALERTA = 'flex items-center gap-[9px] border-0 bg-transparent text-[15px] uppercase text-brand-pink';

export const VAZIO = 'col-span-full py-6 text-center text-base text-content';

/** "30 Dez 2025 às 18h37", como no design. */
export function formatarEnvio(time: number): string {
  const texto = format(new Date(time), "dd MMM yyyy 'às' HH'h'mm", { locale: ptBR });

  return texto.replace(/^(\d{2}) (\p{L})/u, (_, dia: string, letra: string) => `${dia} ${letra.toUpperCase()}`);
}

export const CARREGAR_MAIS =
  'mx-auto rounded-md border-0 bg-brand-yellow px-6 py-3 font-display text-[13px] font-bold uppercase text-brand-blue hover:brightness-95 disabled:cursor-wait disabled:opacity-70';

export { default as AvatarDoRemetente } from './AvatarDoRemetente';
